// Same-origin check for `?redirect=` round-trips (login → set-password → back).
// Only a path starting with a single '/' is honoured: '//host' is
// protocol-relative and browsers also read '/\\host' as '//host'.
// Dependency-free so the client bundle can share it.
export function safeRedirectPath(raw: string | null | undefined, fallback = '/'): string {
  return raw && /^\/(?![\/\\])/.test(raw) ? raw : fallback;
}
